import { render } from "./divider.md?vue&type=template&id=279e120b"
import script from "./divider.md?vue&type=script&lang=js"
export * from "./divider.md?vue&type=script&lang=js"
script.render = render

export default script